module.exports = __webpack_public_path__ + "img/update-title01.42067ea2.png";